// extracted by mini-css-extract-plugin
export default {"fields":"Cor5SB","time":"xRkyfH","mobile":"BKEDhB"};